import api from '../utils/api';
import { Clerk } from '../types';

export const getClerkByClerkNumber = async (
  clerkNumber: string
): Promise<Clerk> => {
  const { data } = await api.get(`/clerk/${clerkNumber}`);
  return data;
};
